var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityExerciseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.986 18.8637C42.0127 27.6904 34.4127 33.5646 25.4494 34.6646C16.486 35.7629 9.55436 31.6729 8.52602 22.8462C7.49769 14.0196 7.08852 2.18207 16.0519 1.0829C25.0152 -0.0170975 39.9577 10.0379 40.986 18.8637Z",
    fill: "#DDFFEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1087 10.5626C28.6499 10.5626 29.8992 9.31738 29.8992 7.78131C29.8992 6.24523 28.6499 5 27.1087 5C25.5676 5 24.3182 6.24523 24.3182 7.78131C24.3182 9.31738 25.5676 10.5626 27.1087 10.5626Z",
    fill: "#284744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9498 8.4557L30.7416 14.6656L32.1869 12.3178C32.6123 11.6268 33.5074 11.3987 34.2107 11.7915L34.2842 11.8352C34.993 12.2766 35.2121 13.2051 34.7751 13.9151L32.9389 16.8984C32.8776 16.998 32.8065 17.088 32.7277 17.1679C32.6944 17.2749 32.6488 17.3801 32.5901 17.4813C32.1698 18.2069 31.2389 18.4556 30.5109 18.0366L27.5932 16.3577L24.9436 20.6063L24.9757 20.6942L26.5747 21.5148C27.1319 21.8315 27.4106 22.4538 27.4106 23.3817C27.4106 24.1888 26.4755 25.0186 24.6054 25.871L20.7965 28.1791C20.7611 28.2554 20.7204 28.3304 20.6746 28.4036L18.3892 32.0489C17.7953 32.9962 16.5432 33.2844 15.5927 32.6924C14.6422 32.1004 14.3531 30.8524 14.9471 29.905L17.2324 26.2598C17.355 26.0643 17.5056 25.8969 17.6757 25.7595L19.4871 22.9142L19.0812 22.6497C17.6326 21.7049 17.4586 20.3308 18.5593 18.5276L18.6118 18.4427L21.8354 13.0444L19.7105 11.8216L17.475 15.3879C17.0295 16.0984 16.0905 16.3145 15.3776 15.8705C14.6647 15.4265 14.4479 14.4906 14.8934 13.78L17.7164 9.2771C17.7399 9.23958 17.7648 9.20344 17.791 9.16871C17.8141 9.11534 17.8407 9.06265 17.8706 9.01099C18.2909 8.28538 19.2218 8.03677 19.9498 8.4557Z",
    fill: "#284744"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18.5151C3 17.8932 3.50415 17.389 4.12604 17.389H14.6712C15.293 17.389 15.7972 17.8932 15.7972 18.5151C15.7972 19.137 15.293 19.6411 14.6712 19.6411H4.12604C3.50415 19.6411 3 19.137 3 18.5151Z",
    fill: "#284744"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95324 23.8388C6.92138 23.2193 7.41515 22.6995 8.03553 22.6995H12.9923C13.5691 22.6995 14.0449 23.1514 14.0745 23.7275C14.1064 24.3471 13.6126 24.8669 12.9923 24.8669H8.03553C7.45864 24.8669 6.98287 24.415 6.95324 23.8388Z",
    fill: "#284744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityExerciseIcon);
export default __webpack_public_path__ + "static/media/activity-exercise-icon.2f76b324239162d1404e86f2f031b552.svg";
export { ForwardRef as ReactComponent };